import React from 'react'
import PrivateRoute from '../auth/PrivateRoute'
import { withRouter, Redirect, Switch } from 'react-router-dom'
import PricingContractTable from './PricingContractTable'
import PricingContractGeneralFormPage from './PricingContractGeneralFormPage'
import PricingContractProductPriceFormPage from './PricingContractProductPriceFormPage'
import { findAccessLevel } from '../../modules/accessRoute'

class PricingContractPage extends React.Component {
  handleSubmit = (contractorType) => {
    this.props.history.push(`/pricingContract/` + contractorType || '')
  }

  table = ({
    match: {
      params: { contractorType },
    },
  }) => {
    if (contractorType !== 'template') {
      return (
        <PricingContractTable
          path="/pricingContract"
          contractorType={contractorType}
          isTemplate={false}
        />
      )
    }
    return <PricingContractTable path="/pricingContract" isTemplate />
  }

  formPage = ({
    match: {
      params: { id, contractorType },
    },
  }) => (
    <PricingContractGeneralFormPage
      id={id}
      contractorType={contractorType}
      onSubmit={this.handleSubmit}
      pricingContractTemplateId={
        this.props.location.state
          ? this.props.location.state.pricingContractTemplateId
          : undefined
      }
    />
  )

  productPricingFormPage = ({
    match: {
      params: { id, contractorType },
    },
  }) => (
    <PricingContractProductPriceFormPage
      id={id}
      onSubmit={this.handleSubmit}
      contractorType={contractorType}
    />
  )

  render() {
    return (
      <Switch>
        <Redirect to="/pricingContract/agent" from="/pricingContract" exact />

        <PrivateRoute
          exact
          path="/pricingContract/agent"
          component={() => (
            <PricingContractTable
              path="/pricingContract"
              contractorType="agent"
              isTemplate={false}
            />
          )}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          exact
          path="/pricingContract/airline"
          component={() => (
            <PricingContractTable
              path="/pricingContract"
              contractorType="airline"
              isTemplate={false}
            />
          )}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          exact
          path="/pricingContract/card"
          component={() => (
            <PricingContractTable
              path="/pricingContract"
              contractorType="card"
              isTemplate={false}
            />
          )}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          exact
          path="/pricingContract/template"
          component={() => (
            <PricingContractTable path="/pricingContract" isTemplate />
          )}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          path="/pricingContract/:contractorType(agent|airline|card|template)/new"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          path="/pricingContract/:contractorType(agent|airline|card|template)/edit/:id"
          component={this.formPage}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />

        <PrivateRoute
          path="/pricingContract/:contractorType(agent|airline|card|template)/pricing/:id"
          component={this.productPricingFormPage}
          ifAnyGranted={findAccessLevel('/pricingContract')}
        />
      </Switch>
    )
  }
}

export default withRouter(PricingContractPage)
